import {
    MOO_PRODUCT_TYPE_DEFAULT_VALUE,
    MOO_HEALTH_CATEGORIES_DEFAULT_VALUE,
    MOO_COMPANY_ID,
} from '../../../Agent/constants';
import {
    NargsHashMapType,
    ProductGuaranteedFileds,
    ProductGuaranteedIXNMOORequestFields as RequestFields,
} from '../../../Agent/types';

export default function GuaranteedIXNCallAdapter(nargs: NargsHashMapType): Result {
    const result: Result = [];

    for (const [name, {value}] of Object.entries(nargs)) {
        let val: {name: string; value: string | number | boolean};
        switch (name) {
            case ProductGuaranteedFileds.state:
                val = {name: RequestFields.state, value};
                break;
            case ProductGuaranteedFileds.gender:
                val = {name: RequestFields.gender, value};
                break;
            case ProductGuaranteedFileds.specifiedFaceAmountMOO:
                val = {name: RequestFields.face_amount, value};
                break;
            case ProductGuaranteedFileds.termPeriod:
                val = {name: RequestFields.product_types, value: MOO_PRODUCT_TYPE_DEFAULT_VALUE};
                break;
            case ProductGuaranteedFileds.healthRatingMOO:
                val = {name: RequestFields.health_categories, value: MOO_HEALTH_CATEGORIES_DEFAULT_VALUE};
                break;
            case ProductGuaranteedFileds.smokerRatingMOO:
                val = {name: RequestFields.tobacco, value: isTobacco(value as string)};
                break;
            case ProductGuaranteedFileds.age:
                val = {name: RequestFields.current_age, value};
                break;
            case ProductGuaranteedFileds.nearestAge:
                val = {name: RequestFields.nearest_age, value};
                break;

            default:
                continue;
        }
        // @ts-ignore
        result.push(val);
    }

    // add Moo carrier
    result.push({name: RequestFields.carrier_ids, value: `${MOO_COMPANY_ID}`});
    // add empty table rates
    result.push({name: RequestFields.table_rates, value: ''});

    return result;
}

function isTobacco(value: string) {
    return !(value as string).toLowerCase().includes('non');
}

type Result = {
    name: string;
    value: string | number | boolean;
}[];
